import { render, staticRenderFns } from "./RuleRestrictionInput.vue?vue&type=template&id=15f04a1c&scoped=true&lang=html&"
import script from "./RuleRestrictionInput.vue?vue&type=script&lang=js&"
export * from "./RuleRestrictionInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f04a1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
